var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240,16.4l223.9,51.3C460.8,260,387.5,389.2,240,462.2C92.5,389.2,19.2,260,16.1,67.7L240,16.4 M240,0L0,55 c0,205.6,76.8,347.3,240,425c163.2-77.7,240-219.4,240-425L240,0L240,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240,49.2L431,93c-1.8,33.4-5.9,64.9-12.4,93.7c-8.7,38.8-21.9,74.3-39.3,105.4c-17.2,30.8-39.2,58.5-65.2,82.2 c-21.4,19.4-46.3,36.9-74.1,52c-27.8-15.1-52.7-32.5-74.1-52c-26.1-23.7-48-51.4-65.2-82.2C83.3,261,70.1,225.5,61.4,186.7 C54.9,157.9,50.8,126.5,49,93L240,49.2 M240,32.8L32.4,80.4c1.3,39.4,5.8,76.2,13.3,109.8c9.1,40.4,22.8,77.2,41,109.7 c18.1,32.3,41.1,61.3,68.4,86.2c24.3,22.1,52.8,41.7,84.8,58.2c32-16.6,60.5-36.1,84.8-58.2c27.3-24.9,50.4-53.9,68.4-86.2 c18.1-32.4,31.9-69.3,41-109.7c7.5-33.6,12-70.4,13.3-109.8L240,32.8L240,32.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 138.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -54.4679 161.1537)",
    width: 272.6,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 223.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -77.7868 274.3957)",
    width: 398.4,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 260.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -99.9784 296.0498)",
    width: 355.8,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefense);
export default __webpack_public_path__ + "static/media/defense.09358c171c069eeb31c8e9c68a96f253.svg";
export { ForwardRef as ReactComponent };